import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { ChevronDownIcon } from 'lucide-react';
import { Badge, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'twyne-new.ui';

import HeaderContainerGrid from '@/components/headerContainer/Grid';
import { HeaderActions, HeaderSeparator, ReportDatePicker, RunButton } from '@/components/reports/header';

const propTypes = {
  onClickFilter: PropTypes.func,
  handleChangeDates: PropTypes.func,
  handleChangeDatesTime: PropTypes.func,
  dates: PropTypes.object,
  sync: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default function Header({ sync, handleChangeDates, dates, handleChangeDatesTime, isLoading }) {
  const [refreshIntervalLabel, setRefreshIntervalLabel] = useState('disabled')
  const [intervalState, setIntervalState] = useState(0)
  const [autoRefresh, setAutoRefresh] = useState()

  useEffect(() => {
    if (!intervalState) {
      clearInterval(autoRefresh)
    }
  })

  function changeRefreshInterval(intervalInMinutes) {
    clearInterval(autoRefresh)
    const interval = intervalInMinutes * 1000 * 60

    if (interval) {
      setAutoRefresh(setInterval(sync, interval))
    }

    let intervalLabel

    if (intervalInMinutes > 0 && intervalInMinutes < 60) {
      intervalLabel = `${intervalInMinutes} minute${intervalInMinutes > 1 ? "s" : ""}`
    } else if (intervalInMinutes >= 60) {
      intervalLabel = `${intervalInMinutes / 60} hour${intervalInMinutes / 60 > 1 ? "s" : ""}`
    } else {
      intervalLabel = "Disabled"
    }
    setRefreshIntervalLabel(intervalLabel)
    setIntervalState(interval)
  }

  return <>
    <HeaderContainerGrid title='Session Report'>
      <HeaderActions>
        <ReportDatePicker dates={dates} onChange={handleChangeDates} />

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Badge
              size='lg'
              color='accent'
              variant='outline'
              className='self-center twy-subtle-accent-hover transition-all cursor-pointer'
            >
              Auto-refresh: {refreshIntervalLabel}
              <ChevronDownIcon size={12} />
            </Badge>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem onClick={() => changeRefreshInterval(0)}>Disabled</DropdownMenuItem>
            <DropdownMenuItem onClick={() => changeRefreshInterval(1)}>1 minute</DropdownMenuItem>
            <DropdownMenuItem onClick={() => changeRefreshInterval(2)}>2 minutes</DropdownMenuItem>
            <DropdownMenuItem onClick={() => changeRefreshInterval(5)}>5 minutes</DropdownMenuItem>
            <DropdownMenuItem onClick={() => changeRefreshInterval(15)}>15 minutes</DropdownMenuItem>
            <DropdownMenuItem onClick={() => changeRefreshInterval(30)}>30 minutes</DropdownMenuItem>
            <DropdownMenuItem onClick={() => changeRefreshInterval(60)}>1 hour</DropdownMenuItem>
            <DropdownMenuItem onClick={() => changeRefreshInterval(120)}>2 hours</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>

        <HeaderSeparator />
        <RunButton isLoading={isLoading} disabled={isLoading} onClick={sync} />
      </HeaderActions>
    </HeaderContainerGrid>
  </>
}

Header.propTypes = propTypes;

